import { useRouter } from "next/router";
import { useLayoutEffect, useState } from "react";
import styles from "./styles.module.scss";

const withPreserveAppQueryParams = (WrappedComponent, preserveHrefPaths = []) => {
  return props => {
    const { query } = useRouter();
    const [isReady, setIsReady] = useState(false);

    useLayoutEffect(() => {
      if (!query.app) {
        setIsReady(true);
        return;
      }

      const handleAnchorClick = event => {
        const target = event.target.closest("a");
        if (target && target.tagName === "A") {
          const originalHref = target.getAttribute("href");

          if (originalHref) {
            const url = new URL(originalHref, window.location.origin);
            const pathname = url.pathname;
            if (preserveHrefPaths.includes(pathname)) {
              event.preventDefault();

              Object.keys(query).forEach(key => {
                url.searchParams.set(key, query[key]);
              });
              const newUrl = new URL(url.toString(), window.location.origin);
              window.location.href = newUrl.toString();
            }
          }
        }
      };

      document.addEventListener("click", handleAnchorClick, { capture: true });
      document.addEventListener("touchend", handleAnchorClick, { capture: true });
      setIsReady(true);
      return () => {
        document.removeEventListener("click", handleAnchorClick, { capture: true });
        document.removeEventListener("touchend", handleAnchorClick, { capture: true });
      };
    }, [query, preserveHrefPaths]);

    return (
      <div className={isReady ? "" : styles["notInteractive"]}>
        <WrappedComponent {...props} />;
      </div>
    );
  };
};

export default withPreserveAppQueryParams;
